import { render } from "./DateRule.vue?vue&type=template&id=4dcf8ae7"
import script from "./DateRule.vue?vue&type=script&lang=js"
export * from "./DateRule.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__